<template>
  <div
    v-if="visible"
    class="o-modal"
    @click.self="hide"
  >
    <div class="o-modal__wrapper">
      <span
        v-if="!disableClose"
        v-accessibility-focus="hide"
        class="o-modal__close"
        :aria-label="$t('accessibility.modal.close')"
      >
        <span class="o-icon o-icon--close o-typography--action"></span>
      </span>
      <div class="o-modal__dialog">
        <div
          ref="scroll-modal"
          class="o-modal__content"
        >
          <div class="o-modal__header">
            <slot name="header"></slot>
          </div>
          <div class="o-modal__body">
            <slot></slot>
          </div>
          <div class="o-modal__footer">
            <slot name="footer"></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
  import { isKey, keyMap } from '@/shared/utils';

  export default {
    name: 'Modal',
    props: {
      disableClose: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        overlay: false,
        visible: false,
      };
    },
    beforeDestroy() {
      enableBodyScroll(this.$el);
      document.removeEventListener('keyup', this.onKeyUp);
    },
    methods: {
      show() {
        document.addEventListener('keyup', this.onKeyUp);
        this.visible = true;
        this.$nextTick(() => {
          disableBodyScroll(this.$el);
        });
      },
      hide() {
        this.$emit('hide');
      },
      onKeyUp(e) {
        if (isKey(keyMap.ESCAPE, e) && !this.disableClose) {
          this.hide();
        }
      },
    },
  };
</script>
